import axios from "axios";
import url from "../config/urlServiceConfig";

const handshakeAPI = {
  getAll: () => axios.get(url.handshake),
  getStatuses: () => axios.get("statuses"),
  getKPIStatuses: () => axios.get("KPIStatuses"),
  getProjectStatuses: () => axios.get("ProjectStatuses"),
  getSystemStatuses: () => axios.get("SystemStatuses"),
};

export default handshakeAPI;
